import { createReducer } from '@reduxjs/toolkit';
import { setIsLoadingAction, setIsErrorAction, setAuthorizedStatusAction, setProfileDataAction, setProfileMenuDataAction, setProfileDealerInfo, setIsLoadedLogoutIframe, } from './actions';
const initialStateProfileMenu = {
    labels: {
        headerMenu_login_label: 'Login',
        headerMenu_signUp_label: 'Sign Up',
        headerMenu_signOut_label: 'Sign Out',
        headerMenu_myYamahaLink_label: 'My Yamaha',
    },
    clientId: '',
    myYamahaLink: '#',
    callbackEndpointUri: '#',
};
const initialState = {
    isLoading: false,
    isError: null,
    isAuthorized: false,
    data: undefined,
    profileMenuData: initialStateProfileMenu,
    isLoadedLogoutIframe: false,
};
function setIsLoadedLogoutIframeReducer(state, { payload }) {
    return {
        ...state,
        isLoadedLogoutIframe: payload,
    };
}
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setIsLoadingAction, (state, action) => ({
        ...state,
        isLoading: action.payload,
    }))
        .addCase(setIsErrorAction, (state, action) => ({
        ...state,
        isLoading: false,
        isError: action.payload,
    }))
        .addCase(setAuthorizedStatusAction, (state, action) => ({
        ...state,
        data: !action.payload ? undefined : state.data,
        isAuthorized: action.payload,
    }))
        .addCase(setProfileDataAction, (state, action) => ({
        ...state,
        data: action.payload,
        isAuthorized: action.payload ? true : false,
    }))
        .addCase(setProfileMenuDataAction, (state, action) => ({
        ...state,
        profileMenuData: action.payload,
    }))
        .addCase(setProfileDealerInfo, (state, action) => ({
        ...state,
        profileDealerInfo: action.payload?.[0],
    }))
        .addCase(setIsLoadedLogoutIframe, setIsLoadedLogoutIframeReducer);
});
